export const autoReloadMesssages = {
    newVersionText: 'We just made an improvement to CTBIDS',
    clickToRefreshText: 'Please click to accept'
}

